"use client";

import React from "react";
import { AppHeaderPrimary } from "@/components/layout/AppHeader";
import PageLayout from "@/components/layout/PageLayout";
import { PermissionsPrefetch } from "@/components/permissions";
import { useParams, usePathname } from "next/navigation";

function Layout({ children }: { children: React.ReactNode }) {
	const pathname = usePathname();
	const { slug } = useParams<{ slug?: string }>();

	if (
		pathname.includes("/place-allocation") ||
		pathname.includes("/place-multiple-allocations")
	) {
		return <>{children}</>;
	}

	const loginUrl = slug && `/invest/${slug}/place-allocation/account`;

	return (
		<>
			<AppHeaderPrimary loginUrl={loginUrl} />
			<PermissionsPrefetch />
			<PageLayout>{children}</PageLayout>
		</>
	);
}

export default Layout;
